export const SLA_SHORT = 'Сроки и бюджет до старта';
export const SLA_FULL = 'Сроки и бюджет до старта';

export const HEADER_SECTIONS = [
  { id: 'adv', label: 'Почему я' },
  { id: 'works', label: 'Кейсы' },
  { id: 'tasks', label: 'Услуги' },
  { id: 'faq', label: 'FAQ' },
  { id: 'contact', label: 'Контакт' },
];

export const HERO_CONTENT = {
  title: 'Сайты, Telegram-боты и веб-приложения — быстро, понятно и под задачу',
  description: ['Разрабатываю сайты и сервисы для бизнеса: оцениваю задачу, предлагаю решение и запускаю проект.'],
  primaryCta: 'Получить план запуска',
  secondaryCta: 'Посмотреть кейсы и бюджеты',
  badges: [SLA_SHORT, 'План в день обращения', 'Дизайн + разработка под ключ'],
};

export const ADV_CONTENT = {
  title: 'Почему Sorokin.dev — оптимальный выбор между фрилансером и агентством',
  subtitle: 'У клиента обычно три пути: сэкономить на старте, переплатить за агентство или выбрать исполнителя, который быстро закрывает задачу без хаоса и сюрпризов.',
  cards: [
    {
      id: 'cheap',
      title: 'Дешёвый исполнитель',
      lead: 'Низкая цена на старте, но часто дороже в итоге.',
      points: [
        { id: 'cheap-price', label: 'Цена', value: 'Низкая цена на старте' },
        { id: 'cheap-start', label: 'Старт', value: 'Быстро, но без чёткого плана' },
        { id: 'cheap-process', label: 'Процесс', value: 'Сроки плывут, много переделок' },
        { id: 'cheap-contact', label: 'СВЯЗЬ', value: 'Ответы с задержками' },
        { id: 'cheap-risk', label: 'Риски', value: 'После запуска может пропасть' },
      ],
    },
    {
      id: 'sorokin',
      title: 'Sorokin.dev',
      lead: 'Работаю напрямую: без лишних менеджеров и размытых сроков.',
      badge: 'Оптимальный выбор',
      isPrimary: true,
      points: [
        { id: 'sorokin-price', label: 'Цена', value: 'По задаче, без переплат' },
        { id: 'sorokin-start', label: 'Старт', value: 'План до старта' },
        { id: 'sorokin-process', label: 'Процесс', value: 'Дизайн + разработка под ключ' },
        { id: 'sorokin-contact', label: 'СВЯЗЬ', value: 'Быстрые ответы и показы этапов' },
        { id: 'sorokin-risk', label: 'Риски', value: 'Сроки и бюджет фиксируются' },
      ],
    },
    {
      id: 'expensive',
      title: 'Дорогое агентство',
      lead: 'Большая команда, но выше бюджет и дольше сроки.',
      points: [
        { id: 'expensive-price', label: 'Цена', value: 'Высокий бюджет' },
        { id: 'expensive-start', label: 'Старт', value: 'Долгий старт и брифинг' },
        { id: 'expensive-process', label: 'Процесс', value: 'Много созвонов и согласований' },
        { id: 'expensive-contact', label: 'СВЯЗЬ', value: 'Через менеджера и созвоны' },
        { id: 'expensive-risk', label: 'Риски', value: 'Часть бюджета уходит на процесс' },
      ],
    },
  ],
  afterword: 'Моя задача — не просто “сделать сайт”, а запустить рабочий инструмент в понятные сроки и в рамках бюджета.',
};

const WORK_CASE_TEMPLATES = {
  landing: {
    serviceType: 'Лендинг + WordPress',
    proofType: 'live',
    proofLabel: 'Публичный проект',
    tags: ['Лендинг', 'WordPress'],
    ctaText: 'Обсудить похожий сайт в Telegram',
    cases: [
      {
        title: 'Репартмент',
        link: 'https://repartment.ru/',
        portfolioFiles: ['4-b.webp', '4-f.webp'],
        cardText: 'Сайт для студии дизайна интерьера и ремонта с услугами, проектами, этапами работы, ценами и заявками',
        niche: 'Лендинг + WordPress',
        timeline: '18–25 дней',
        priceFrom: '120 000 ₽',
        priceRange: '120 000–230 000 ₽',
        problem: 'Студии нужно было упаковать комплексную услугу так, чтобы клиент не терялся между дизайном, ремонтом, мебелью и комплектацией, а быстро понимал формат работы под ключ.',
        solution: ['WordPress-сайт для студии ремонта и дизайна с премиальной визуальной подачей, блоком услуг, портфолио проектов, этапами работы, преимуществами, примерами цен, FAQ и формами консультации.'],
        deliverables: [
          'Понятная презентация услуги “под ключ” без перегруза деталями.',
          'Доверие через портфолио, этапы, цены и объяснение процесса.',
          'Структура, которую удобно отправлять клиенту после первого контакта.',
          'Несколько точек обращения для консультации и записи на обсуждение.',
          'Сайт на WordPress, который можно обновлять без разработчика.',
        ],
        result: 'Сайт собрал все направления студии в одну понятную историю: клиент видит стиль, процесс, ориентиры по бюджету и быстрее доходит до консультации.',
        resultMetric: 'Сделали акцент на премиальной подаче, проектах и заявке на консультацию.',
      },
      {
        title: 'Забор в Москве',
        cardText: 'Лендинг для компании по установке современных заборов с каталогом решений, преимуществами, этапами работы, отзывами и заявкой',
        link: 'https://zabor-na-zakaz.ru/',
        portfolioFiles: ['5-b-sm.webp', '5-f-sm.webp'],
        niche: 'Лендинг + WordPress',
        timeline: '14–21 день',
        priceFrom: '90 000 ₽',
        priceRange: '90 000–170 000 ₽',
        problem: 'Клиенту нужен был сайт под заявки из рекламы: быстро показать варианты заборов, цены, примеры работ и снять сомнения перед расчётом.',
        solution: 'WordPress-лендинг для продажи заборов под ключ: первый экран с оффером, каталог моделей, преимущества производства, этапы работы, отзывы клиентов, примеры выполненных объектов и формы заявки.',
        deliverables: [
          'Понятный выбор вариантов заборов без долгого общения с менеджером.',
          'Доверие через реальные объекты, отзывы и гарантию.',
          'Быстрый сценарий заявки на расчёт стоимости.',
          'Страница, которую можно вести на холодный рекламный трафик.',
          'Удобное обновление цен, фото и условий через WordPress.',
        ],
        result: 'Посетитель быстрее понимает, какой забор подходит под его задачу, видит примеры работ и может сразу запросить расчёт.',
        resultMetric: 'Усилили каталог, реальные объекты и быстрый переход к заявке.',
      },
      {
        title: 'Padel Club',
        cardText: 'Имиджевый сайт для падел-клуба с описанием клуба, преимуществами, правилами игры, тренерами, услугами и контактами',
        niche: 'Лендинг + WordPress',
        timeline: '14–21 день',
        priceFrom: '90 000 ₽',
        priceRange: '90 000–170 000 ₽',
        portfolioFiles: ['6-b.webp', '6-f.webp'],
        link: 'https://padel-vld.ru/',
        problem: 'Нужно было презентовать новый клуб так, чтобы человек, который не знает падел, понял формат игры, атмосферу и захотел записаться.',
        solution: 'WordPress-лендинг для падел-клуба с лёгкой премиальной визуальной подачей: первый экран, блок о клубе, преимущества падела, правила игры, уровни игроков, атмосфера клуба, тренеры, услуги, контакты и карта.',
        deliverables: [
          'Простое объяснение формата клуба для новых посетителей.',
          'Подача атмосферы: спорт, общение и отдых, а не просто аренда корта.',
          'Быстрый сценарий записи на игру или тренировку.',
          'Доверие через тренеров, услуги и визуальную подачу клуба.',
          'Сайт, который легко обновлять под события, акции и расписание.',
        ],
        result: 'Сайт помог объяснить падел без сложных терминов и показать клуб как место, куда можно прийти даже без опыта игры.',
        resultMetric: 'Главный акцент — атмосфера клуба, понятная запись и снятие барьера для новичков.',
      },
      {
        title: 'Грин Руф',
        cardText: 'Сайт-каталог для компании по зелёным кровлям и благоустройству с продукцией, решениями, проектами и заявкой',
        niche: 'React + Next.js',
        timeline: '20–30 дней',
        priceFrom: '160 000 ₽',
        priceRange: '160 000–300 000 ₽',
        portfolioFiles: ['7-b.webp', '7-f.webp'],
        link: 'https://greenroof-mart.ru/',
        problem: 'Компания продавала сложные технические решения, и сайт должен был быстро объяснять, что именно можно заказать и где это применяется.',
        solution: 'Next.js-сайт с каталогом продукции, крупным промо-экраном, блоками технологических решений, преимуществами компании, реализованными проектами, популярными товарами и контактами для обращения.',
        deliverables: [
          'Понятная подача технического продукта для неподготовленного клиента.',
          'Каталог, который помогает разобраться в материалах и решениях.',
          'Доверие через проекты, цифры компании и направления работ.',
          'Быстрый переход от изучения решений к заявке или каталогу.',
          'Компонентная структура, которую можно расширять под новые товары.',
        ],
        result: 'Сайт объясняет зелёные кровли и сопутствующие решения простым языком, чтобы клиент быстрее понимал задачу и переходил к запросу расчёта.',
        resultMetric: 'Сделали упор на каталог, технологии и доверие к экспертности компании.',
      },
      {
        title: 'Uno Estetico',
        cardText: 'Лендинг для производителя премиального оборудования для домашних спортзалов с каталогом, преимуществами, видео-примерами и заявкой',
        niche: 'Лендинг + WordPress',
        timeline: '14–21 день',
        priceFrom: '100 000 ₽',
        priceRange: '100 000–190 000 ₽',
        portfolioFiles: ['9-b.webp', '9-f.webp'],
        link: 'https://unoestetico.pro/',
        problem: 'Нужно было показать дорогой индивидуальный продукт так, чтобы клиент видел не просто оборудование, а готовое премиальное решение для дома.',
        solution: 'WordPress-лендинг для продажи премиального спортивного оборудования: первый экран с сильным оффером, каталог категорий, преимущества производства, видео-примеры работ, этапы создания проекта и форма обратной связи.',
        deliverables: [
          'Премиальная подача продукта без ощущения типового каталога.',
          'Акцент на индивидуальном производстве и качестве материалов.',
          'Понятный путь от интереса к заявке на персональный проект.',
          'Визуальные доказательства уровня работ через фото и видео.',
          'Удобное обновление ассортимента и материалов через WordPress.',
        ],
        result: 'Сайт помогает объяснить, почему индивидуальный домашний спортзал стоит дороже обычного оборудования и за что именно платит клиент.',
        resultMetric: 'Усилили ценность продукта через визуал, примеры и понятный сценарий заявки.',
      },
      {
        title: 'Kraftainer',
        cardText: 'Лендинг для компании по производству модульных домов и контейнерных решений с кейсами, преимуществами, видео и заявкой',
        niche: 'Лендинг + WordPress',
        timeline: '18–25 дней',
        priceFrom: '120 000 ₽',
        priceRange: '120 000–230 000 ₽',
        portfolioFiles: ['10-b.webp', '10-f.webp'],
        link: 'https://kraftainer.ru/',
        problem: 'Модульные дома вызывают много вопросов по качеству, срокам, утеплению и установке — сайт должен был закрывать эти сомнения до заявки.',
        solution: 'WordPress-лендинг для продажи модульных решений: первый экран с оффером, видео-презентация, блоки выгод, разбор сценариев использования, кейсы объектов, этапы производства, ответы на возражения и формы заявки.',
        deliverables: [
          'Понятное объяснение сложного продукта без технической перегрузки.',
          'Доверие через видео, кейсы и реальные сценарии применения.',
          'Ответы на частые сомнения по качеству, срокам и монтажу.',
          'Быстрый путь к расчёту проекта под конкретную задачу.',
          'Сайт на WordPress, который можно развивать вместе с линейкой решений.',
        ],
        result: 'Сайт показывает модульные объекты как понятное готовое решение, а не рискованный эксперимент: пользователь видит примеры, процесс и может запросить расчёт.',
        resultMetric: 'Закрыли основные возражения и усилили доверие через кейсы и видео.',
      },
      {
        title: 'Академ-Лазер',
        cardText: 'Лендинг для компании по металлообработке с услугами, прайс-листом, преимуществами, расчётом стоимости и контактами',
        niche: 'Лендинг + WordPress',
        timeline: '10–18 дней',
        priceFrom: '80 000 ₽',
        priceRange: '80 000–160 000 ₽',
        portfolioFiles: ['11-b.webp', '11-f.webp'],
        link: 'https://akademlaser.ru/',
        problem: 'B2B-клиентам нужно было быстро понять, какие задачи по металлообработке можно передать компании и как отправить запрос на расчёт.',
        solution: 'WordPress-лендинг для производственной компании: первый экран с ключевыми услугами, блок прайс-листа, логотипы клиентов, преимущества, CTA на расчёт стоимости, карта с адресом и контактные блоки.',
        deliverables: [
          'Понятная презентация услуг металлообработки для B2B-клиентов.',
          'Быстрый сценарий отправки чертежей и запроса стоимости.',
          'Доверие через клиентов, опыт, доставку и производственные преимущества.',
          'Контакты и карта без лишнего поиска по сайту.',
          'WordPress-структура для обновления услуг, цен и информации.',
        ],
        result: 'Сайт стал рабочей точкой входа для заявок: клиент видит услуги, понимает формат расчёта и может быстро отправить запрос по своему изделию.',
        resultMetric: 'Сфокусировали страницу на заявках по чертежам и доверии к производству.',
      },
      {
        title: 'КЛЮСА',
        cardText: 'Лендинг для студии росписи стен и фасадов с услугами, портфолио работ, квизом на расчёт стоимости, блогом и заявкой',
        niche: 'Лендинг + WordPress',
        timeline: '18–25 дней',
        priceFrom: '120 000 ₽',
        priceRange: '120 000–230 000 ₽',
        portfolioFiles: ['12-b.webp', '12-f.webp'],
        link: 'https://klyusa.ru/',
        problem: 'Услугу художественной росписи нужно было показать как профессиональную работу под задачу клиента, а не просто красивую галерею картинок.',
        solution: 'WordPress-лендинг для студии росписи с выразительным первым экраном, блоком услуг, презентацией автора, квизом на расчёт стоимости, портфолио проектов, FAQ, блогом и контактными блоками.',
        deliverables: [
          'Подача росписи как полноценной услуги для интерьеров и бизнеса.',
          'Доверие через автора, портфолио, видео и реальные проекты.',
          'Квиз для первичного расчёта без долгой переписки.',
          'Ответы на частые вопросы перед заказом росписи.',
          'WordPress-сайт, который можно наполнять новыми работами и статьями.',
        ],
        result: 'Сайт помогает клиенту представить будущую роспись в своём пространстве, увидеть уровень работ и перейти к обсуждению идеи с понятным стартом.',
        resultMetric: 'Сделали упор на портфолио, авторскую подачу и быстрый расчёт проекта.',
      },
      {
        title: 'Track&Check',
        cardText: 'Корпоративный сайт для сервисного обслуживания дозирующего оборудования с портфелем услуг, картой присутствия, партнёрами и контактами',
        niche: 'Лендинг + WordPress',
        timeline: '14–21 день',
        priceFrom: '90 000 ₽',
        priceRange: '90 000–180 000 ₽',
        portfolioFiles: ['13-b.webp', '13-f.webp'],
        link: 'https://track-check.ru/',
        problem: 'Компания работает в техническом B2B-сегменте, где важно быстро показать масштаб, компетенцию и понятный список сервисных задач.',
        solution: 'WordPress-сайт для B2B-сервисной компании с первым экраном, блоком о компании, портфелем услуг, преимуществами, картой присутствия, партнёрами, контактами и FAQ.',
        deliverables: [
          'Сайт, который можно использовать как презентацию сервисной компании.',
          'Понятное объяснение услуг без перегруза техническими деталями.',
          'Доверие через географию работы, партнёров и опыт.',
          'Быстрый переход к контакту для обсуждения обслуживания.',
          'Основа для развития сайта под новые услуги и регионы.',
        ],
        result: 'Сайт стал понятной B2B-презентацией: клиент видит, чем занимается компания, где она работает и как быстро выйти на контакт.',
        resultMetric: 'Акцент сделали на масштабе, сервисной экспертизе и доверии для B2B-клиентов.',
      },
      {
        title: 'Edencraft',
        cardText: 'Лендинг для студии ландшафтного дизайна под ключ с галереей проектов, стоимостью работ, этапами, услугами, документами и заявкой',
        niche: 'Лендинг + WordPress',
        timeline: '18–25 дней',
        priceFrom: '120 000 ₽',
        priceRange: '120 000–230 000 ₽',
        portfolioFiles: ['14-b.webp', '14-f.webp'],
        link: 'https://edencraft.ru/',
        problem: 'Ландшафтный дизайн сложно продавать без визуала и понятного процесса — клиенту нужно было показать уровень проектов, стоимость и этапы работы.',
        solution: 'WordPress-лендинг для студии ландшафтного дизайна с сильным первым экраном, галереей реализованных проектов, блоком стоимости работ, этапами проектирования, формой заявки, услугами, информацией о компании, документами и FAQ.',
        deliverables: [
          'Презентация услуги под ключ без ощущения “просто красивые сады”.',
          'Доверие через галерею проектов, документы и опыт компании.',
          'Понятные ориентиры по стоимости до обращения.',
          'Быстрый сценарий заявки на консультацию и расчёт.',
          'WordPress-сайт, который можно дополнять проектами и услугами.',
        ],
        result: 'Сайт помогает клиенту увидеть уровень студии, понять порядок цен и быстрее перейти от вдохновения к заявке на консультацию.',
        resultMetric: 'Усилили визуал, стоимость и понятный путь от просмотра проектов к обращению.',
      },
      {
        title: 'Drive Academy',
        cardText: 'Лендинг для автошколы с программой обучения, тарифами, результатами курса, FAQ и формами заявки',
        niche: 'Лендинг',
        timeline: '10–16 дней',
        priceFrom: '70 000 ₽',
        priceRange: '70 000–140 000 ₽',
        portfolioFiles: ['15-b.webp', '15-f.webp'],
        link: 'https://art89-prog.github.io/drive/',
        problem: 'Нужно было быстро объяснить ценность ускоренного обучения и помочь человеку выбрать формат без длинных консультаций.',
        solution: 'Лендинг для онлайн-продвижения курса автошколы: первый экран с оффером, блоки для разных типов учеников, программа обучения, тарифы, форма вопроса, результаты прохождения курса и FAQ.',
        deliverables: ['Понятное объяснение курса для разных типов учеников.', 'Сравнение форматов обучения без перегруза информацией.', 'Быстрый переход к заявке или вопросу по обучению.', 'Структура страницы под рекламный трафик.', 'Адаптивный лендинг, который удобно показывать с телефона.'],
        result: 'Лендинг помогает пользователю быстро понять формат курса, сравнить варианты и оставить заявку без лишних переходов.',
        resultMetric: 'Сделали акцент на программе, тарифах и простом решении “подходит / не подходит”.',
      },
      {
        title: 'Dumrauf',
        cardText: 'Лендинг для команды мастеров по малярным работам с услугами, примерами работ, ценами, преимуществами, отзывами и заявкой',
        niche: 'Лендинг + WordPress',
        timeline: '14–21 день',
        priceFrom: '90 000 ₽',
        priceRange: '90 000–180 000 ₽',
        portfolioFiles: ['16-b.webp', '16-f.webp'],
        link: 'https://dumrauf.pro/',
        problem: 'В отделке клиенту важно заранее увидеть качество, порядок цен и понять, что бригада работает аккуратно и без хаоса.',
        solution: 'WordPress-лендинг для команды мастеров с первым экраном под заявку, видео-блоком, карточками услуг, примерами работ, прайсом за м², преимуществами, этапами работы, отзывами, сопутствующими услугами и контактами.',
        deliverables: [
          'Понятная подача малярных работ для частных и коммерческих клиентов.',
          'Доверие через реальные примеры, видео, отзывы и процесс работы.',
          'Ориентиры по цене до первого звонка.',
          'Быстрый сценарий заявки на расчёт стоимости.',
          'Сайт на WordPress для обновления работ, цен и услуг.',
        ],
        result: 'Сайт помогает показать бригаду как понятного подрядчика: пользователь видит качество работ, цены и быстрее решается на расчёт.',
        resultMetric: 'Упор сделали на реальные работы, цену за м² и доверие к команде.',
      },
      {
        title: 'Кинеко',
        cardText: 'Лендинг для строительной компании по инженерным сетям с презентацией услуг, партнёрами, заявкой на расчёт и контактами',
        niche: 'Лендинг + WordPress',
        timeline: '14–21 день',
        priceFrom: '100 000 ₽',
        priceRange: '100 000–190 000 ₽',
        portfolioFiles: ['17-b.webp', '17-f.webp'],
        link: 'https://kineko.ru/',
        problem: 'Для B2B-заказчиков важно было быстро понять специализацию компании, уровень клиентов и возможность рассчитать работы по объекту.',
        solution: 'WordPress-лендинг для компании по строительству инженерных сетей: первый экран с оффером, преимуществами, блоком заказчиков и партнёров, формой расчёта стоимости, контактами и понятной структурой для обращения.',
        deliverables: [
          'Деловая презентация компании для B2B-клиентов.',
          'Понятное позиционирование в инженерных сетях и строительных работах.',
          'Доверие через партнёров, заказчиков и преимущества компании.',
          'Быстрый сценарий заявки на расчёт по объекту.',
          'WordPress-структура для обновления информации без разработчика.',
        ],
        result: 'Сайт помогает быстро показать компанию потенциальному заказчику: специализацию видно сразу, доверие усиливают партнёры, а заявка ведёт к расчёту работ.',
        resultMetric: 'Сфокусировали страницу на B2B-доверии и запросе стоимости по объекту.',
      },
      {
        title: 'Shebei CHENGSE',
        cardText: 'Корпоративный сайт для торгово-логистической компании с презентацией товаров, схемой работы, преимуществами и контактами',
        niche: 'Лендинг + WordPress',
        timeline: '10–18 дней',
        priceFrom: '80 000 ₽',
        priceRange: '80 000–160 000 ₽',
        portfolioFiles: ['18-b.webp', '18-f.webp'],
        link: 'https://shebey.kg/',
        problem: 'Компании нужно было понятно объяснить международным B2B-клиентам, какие товары она поставляет и как проходит работа.',
        solution: 'Корпоративный лендинг с первым экраном на английском языке, блоком категорий товаров, пошаговой схемой работы, преимуществами компании, контактной информацией и картой офиса.',
        deliverables: [
          'Англоязычная презентация компании для международных клиентов.',
          'Понятная подача направлений поставок и категорий товаров.',
          'Объяснение схемы работы от запроса до получения товара.',
          'Быстрый доступ к контактам и офису компании.',
          'Сайт, который можно использовать в переговорах и переписке.',
        ],
        result: 'Сайт стал короткой и понятной презентацией для B2B-клиентов: что поставляет компания, как устроен процесс и куда обращаться.',
        resultMetric: 'Сделали акцент на понятной схеме работы и доверии для международной аудитории.',
      },
      {
        title: 'Череповецлес',
        cardText: 'Корпоративный сайт для лесопромышленной компании с презентацией производства, направлений деятельности, географии экспорта, пресс-центром и контактами',
        niche: 'Лендинг + WordPress',
        timeline: '18–25 дней',
        priceFrom: '120 000 ₽',
        priceRange: '120 000–240 000 ₽',
        portfolioFiles: ['19-b.webp', '19-f.webp'],
        link: 'https://cherles.com/',
        problem: 'Крупному производству нужен был сайт не только “для контактов”, а как имиджевая площадка для партнёров, клиентов и рынка.',
        solution: 'WordPress-сайт для производственной компании с крупным первым экраном, блоком заготовки и производства, видео-презентацией, направлениями деятельности, картой географии поставок, пресс-центром и контактной информацией.',
        deliverables: [
          'Имиджевая презентация масштаба промышленной компании.',
          'Понятная подача направлений производства и продукции.',
          'Доверие через видео, географию поставок и корпоративные разделы.',
          'Структура для новостей, пресс-центра и обновлений компании.',
          'WordPress-сайт, который можно развивать как официальный ресурс бренда.',
        ],
        result: 'Сайт показывает компанию как крупного и устойчивого игрока: посетитель видит производство, продукцию, географию поставок и корпоративную повестку.',
        resultMetric: 'Усилили имидж бренда, масштаб производства и доверие партнёров.',
      },
      {
        title: 'Алюмострой',
        cardText: 'Лендинг для компании по алюминиевому остеклению с портфолио объектов, каталогом систем, квизом, преимуществами, документами и заявкой',
        niche: 'Лендинг + WordPress',
        timeline: '18–25 дней',
        priceFrom: '120 000 ₽',
        priceRange: '120 000–230 000 ₽',
        portfolioFiles: ['20-b.webp', '20-f.webp'],
        link: 'https://alumostroy.ru/',
        problem: 'В остеклении клиенту важно увидеть реальные объекты, понять варианты конструкций и быстро запросить расчёт под свой проект.',
        solution: 'WordPress-лендинг для компании по остеклению: первый экран с оффером, портфолио выполненных объектов, формы расчёта, каталог алюминиевых систем, преимущества, этапы работы, документы, отзывы, контакты и карта.',
        deliverables: [
          'Понятная подача услуг остекления для частных и коммерческих объектов.',
          'Доверие через портфолио, документы, отзывы и специалиста.',
          'Быстрый сценарий предварительного расчёта стоимости.',
          'Объяснение вариантов систем без сложной технической перегрузки.',
          'WordPress-сайт для обновления объектов, документов и услуг.',
        ],
        result: 'Сайт помогает клиенту увидеть реальные примеры остекления, разобраться в вариантах решений и быстро отправить заявку на расчёт.',
        resultMetric: 'Упор сделали на портфолио объектов, документы и быстрый расчёт.',
      },
    ],
  },
  react: {
    serviceType: 'React + Node.js',
    proofType: 'nda',
    proofLabel: 'NDA: детали по запросу',
    tags: ['React', 'Node.js', 'MVP'],
    ctaText: 'Нужен похожий React/Node.js проект',
    cases: [
      {
        title: 'SunCityHotels',
        cardText: 'Сервис бронирования отелей с поиском номеров, фильтрами, карточками объектов, акциями, картой и страницей выдачи',
        niche: 'React + Next.js',
        timeline: '30–45 дней',
        priceFrom: '250 000 ₽',
        priceRange: '250 000–500 000 ₽',
        portfolioFiles: ['r4-b.webp', 'r4-1f.webp', 'r4-2f.webp'],
        link: 'https://suncityhotels.ru/',

        problem: 'Нужно было сделать удобный сервис для выбора и бронирования отелей: пользователь должен быстро указать даты, гостей, город, найти подходящий объект, отфильтровать варианты и перейти к просмотру деталей номера.',

        solution: 'Сервис бронирования на React/Next.js с главным экраном поиска, подборкой отелей, акциями, картой, страницей выдачи, фильтрами по удобствам и цене, карточками объектов и быстрым переходом к вариантам размещения.',

        deliverables: [
          'Главная страница с крупным промо-экраном, формой бронирования, выбором дат, гостей и направлений.',
          'Блок выбора отеля с карточками объектов, фото, описанием, тегами и быстрым переходом к деталям.',
          'Раздел акций для специальных предложений и сезонных скидок.',
          'Интерактивная карта с расположением отелей и точками объектов.',
          'Страница каталога отелей с выдачей, количеством найденных вариантов и закреплённой картой.',
          'Фильтры по удобствам, цене за сутки и параметрам номера.',
          'Карточки отелей с фото, адресом, удобствами, типом номера, количеством гостей и ценой за сутки.',
          'Навигация по разделам: правила, бронирование, акции, контакты и вход в аккаунт.',
          'Футер с юридическими ссылками, контактами и разделами для гостей.',
          'Адаптивная верстка и компонентная структура под развитие сервиса бронирования.',
        ],

        result: 'Сайт стал полноценной онлайн-витриной для сети отелей: пользователь может выбрать город, даты и гостей, посмотреть подходящие варианты, отфильтровать выдачу, оценить расположение на карте и перейти к бронированию.',

        resultMetric: 'Готовый React/Next.js сервис под бронирование: поиск отелей, фильтры, карточки объектов, акции, карта, каталог выдачи и структура под дальнейшее развитие личного кабинета.',
      },
      {
        title: 'LibrAI',
        portfolioFiles: ['r5-b.webp', 'r5-1f.webp', 'r5-2f.webp', 'r5-3f.webp'],
        link: 'https://librai.ru/',
        cardText: 'SaaS-платформа для поиска и работы с корпоративными документами через AI-поиск, проекты, хранилище файлов и Telegram-авторизацию',
        niche: 'React + Node.js',
        timeline: '35–60 дней',
        priceFrom: '320 000 ₽',
        priceRange: '320 000–700 000 ₽',

        problem: 'Компании нужно было собрать единое пространство для хранения и AI-поиска по документам, чтобы сотрудники не тратили время на ручной поиск информации по чатам, папкам и файлам.',

        solution: ['Разработал SaaS-платформу на React + Node.js с AI-поиском по документам, системой проектов, загрузкой файлов, хранением данных, Telegram-авторизацией, тарифами и личным кабинетом.'],

        deliverables: [
          'Единая система для хранения и быстрого поиска рабочих документов.',
          'AI-поиск, который помогает находить информацию без ручного просмотра файлов.',
          'Понятный интерфейс для сотрудников без сложного onboarding.',
          'Основа для масштабирования сервиса и подключения новых AI-сценариев.',
          'Личный кабинет с проектами, тарифами и управлением документами.',
        ],

        result: 'Сервис помог собрать рабочие документы в одном месте и упростить поиск информации внутри команды: вместо ручного просмотра файлов пользователь получает быстрый AI-ответ с источником.',

        resultMetric: 'Главный акцент сделали на AI-поиске, удобстве ежедневной работы и понятной SaaS-структуре.',
      },
      {
        title: 'ContentPRO',
        link: 'https://contentpro.cloud/',
        cardText: 'Веб-сервис на React и Node.js для работы с товарами, AI-копирайтингом, аналитикой маркетплейсов и интеграциями',
        niche: 'React + Node.js',
        timeline: '35–55 дней',
        priceFrom: '300 000 ₽',
        priceRange: '300 000–650 000 ₽',
        portfolioFiles: ['r3-b.webp', 'r3-1f.webp', 'r3-2f.webp', 'r3-3f.webp'],
        problem: 'Нужно было собрать в одном интерфейсе аналитику, товары, заказы и AI-инструменты так, чтобы сервис выглядел рабочим продуктом, а не набором разрозненных экранов.',
        solution: 'React + Node.js сервис с личным кабинетом, дашбордом аналитики, AI-копирайтером для генерации описаний товаров, разделами товаров, заказов, финансов, склада, интеграций и настроек.',
        deliverables: [
          'Рабочий SaaS-интерфейс под ежедневные задачи продавца.',
          'Понятная навигация между аналитикой, товарами и AI-инструментами.',
          'Основа для подключения новых разделов и интеграций.',
          'AI-сценарий, который экономит время на описаниях товаров.',
          'Backend-логика для данных, запросов и дальнейшего развития сервиса.',
        ],
        result: 'Получился личный кабинет, в котором продавец может смотреть показатели, работать с товарами и генерировать описания без перехода между разными инструментами.',
        resultMetric: 'Собрали основу SaaS-продукта: аналитика, AI-копирайтер и структура под масштабирование.',
      },
      {
        title: 'LEGENDA',
        portfolioFiles: ['r2-b.webp', 'r2-1f.webp'],
        cardText: 'Имиджевый WordPress-сайт для девелопера с презентацией жилых проектов, новостями и разделами компании',
        link: 'https://legenda-dom.ru/',
        niche: 'Лендинг + WordPress',
        timeline: '20–30 дней',
        priceFrom: '140 000 ₽',
        priceRange: '140 000–260 000 ₽',
        problem: 'Девелоперу нужен был сайт, который поддерживает образ бренда и красиво презентует проекты, а не просто перечисляет объекты.',
        solution: ['WordPress-сайт для девелоперской компании с крупным первым экраном, презентацией жилого проекта, блоками направлений, новостями, навигацией по разделам и фирменной визуальной подачей бренда.'],
        deliverables: [
          'Имиджевая подача бренда для дорогого сегмента недвижимости.',
          'Презентация проектов с акцентом на визуал и ощущение масштаба.',
          'Структура для новостей, направлений и регулярного обновления.',
          'Переходы к ключевым разделам без перегруза навигации.',
          'WordPress-сайт, который удобно поддерживать внутри команды.',
        ],
        result: 'Сайт работает как витрина девелопера: поддерживает премиальный образ, показывает проекты и помогает пользователю быстро перейти к нужному направлению.',
        resultMetric: 'Сделали акцент на бренде, визуале проектов и имиджевой подаче.',
      },
      {
        title: 'Client Portal',
        portfolioFiles: [],
        cardText: 'MVP-платформа для ежедневной работы с данными',
        niche: 'Личный кабинет',
        timeline: '30 дней',
        priceFrom: '260 000 ₽',
        priceRange: '260 000–420 000 ₽',
        problem: 'Команде нужен был не красивый прототип, а рабочий кабинет, который выдержит первые реальные процессы и дальнейшие итерации.',
        solution: ['Сделал архитектуру, которую можно расширять без полной переработки продукта.'],
        result: 'Клиент получил рабочую основу продукта, с которой можно запускать первые процессы и постепенно расширять функциональность.',
        resultMetric: 'Главный результат — MVP без тупика в архитектуре.',
        deliverables: [
          'Рабочая база для личного кабинета и внутренних процессов.',
          'Архитектура, которую можно развивать без полной переделки.',
          'Понятный пользовательский путь для ежедневной работы.',
          'Основа под роли, данные и будущие разделы.',
          'MVP, который можно показывать команде и дорабатывать по обратной связи.',
        ],
      },
      {
        title: 'Analytics Panel',
        portfolioFiles: [],
        cardText: 'Сервис с ролями, фильтрами и сценариями под реальные процессы',
        niche: 'SaaS',
        timeline: '14 дней',
        priceFrom: '140 000 ₽',
        priceRange: '140 000–220 000 ₽',
        problem: 'Нужно было быстро собрать интерфейс и серверную логику под реальные сценарии, чтобы команда могла проверить продукт на пользователях.',
        solution: ['Собрал фронт на React, подключил API и реализовал ключевые пользовательские сценарии.'],
        result: 'Клиент получил рабочую панель, которую можно использовать в процессах и развивать после проверки гипотез.',
        resultMetric: 'Собрали ядро продукта в срок и закрыли основные пользовательские сценарии.',
        deliverables: [
          'MVP с ключевыми сценариями вместо абстрактного прототипа.',
          'Интерфейс, который учитывает роли, фильтры и рабочие процессы.',
          'Связка frontend и backend в единую систему.',
          'Основа для тестирования продукта на реальных пользователях.',
          'Структура для доработок после первых итераций.',
        ],
      },
      {
        title: 'ECRZ Real Estate',
        portfolioFiles: ['r1-b.webp', 'r1-1f.webp'],
        link: 'https://ecrz.by/',
        cardText: 'Сайт агентства недвижимости на Next.js с каталогом объектов, фильтрами, карточками квартир и формами обращения',
        niche: 'React + Next.js',
        timeline: '25–35 дней',
        priceFrom: '180 000 ₽',
        priceRange: '180 000–350 000 ₽',
        problem: 'Агентству недвижимости нужен был сайт, где пользователь быстро подбирает объект по параметрам, а не теряется в длинном списке предложений.',
        solution: ['Next.js-сайт для агентства недвижимости с главной страницей, каталогом квартир, фильтрами, сортировкой, карточками объектов, контактными блоками, валютой, быстрыми мессенджерами и формой заказа звонка.'],
        deliverables: [
          'Онлайн-витрина объектов с понятным поиском и фильтрами.',
          'Карточки недвижимости, которые помогают быстрее принять решение.',
          'Удобный путь от просмотра объекта к звонку или заявке.',
          'Структура под расширение каталога и новых типов недвижимости.',
          'Frontend на Next.js с компонентной логикой под развитие проекта.',
        ],
        result: 'Сайт помогает пользователю быстрее найти подходящую недвижимость, посмотреть ключевые параметры и сразу связаться с агентством.',
        resultMetric: 'Главный акцент — удобный каталог, фильтры и быстрый контакт.',
      },
    ],
  },
  telegram: {
    serviceType: 'Telegram mini app / bot',
    proofType: 'nda',
    proofLabel: 'Telegram-кейс',
    tags: ['Telegram', 'Bot', 'Mini App'],
    ctaText: 'Обсудить Telegram-задачу',
    cases: [
      {
        title: 'Bonsai Grow Mini App',
        portfolioFiles: ['t1-b.webp', 't1-1f.webp', 't1-2f.webp', 't1-3f.webp'],
        cardText: 'Telegram Mini App с игровой механикой выращивания бонсая, заданиями, магазином улучшений, балансом и наградами',
        niche: 'Telegram Mini App',
        timeline: '30–45 дней',
        priceFrom: '220 000 ₽',
        priceRange: '220 000–450 000 ₽',
        problem: 'Нужно было сделать Telegram Mini App, в которое пользователь будет возвращаться ради прогресса, заданий и наград, а не просто открыть один раз.',
        solution: ['Telegram Mini App с игровым интерфейсом, главным экраном бонсая, внутренней валютой, системой уровней, заданиями, магазином улучшений, друзьями, балансом, onboarding-экранами и модальными сценариями подтверждения действий.'],
        link: 'https://t.me/OrbyGameBot',
        deliverables: [
          'Игровой цикл с регулярным возвратом пользователя.',
          'Понятная система прогресса, валюты и наград.',
          'Задания и улучшения, которые дают повод продолжать игру.',
          'Мобильный интерфейс, адаптированный под Telegram.',
          'Структура для расширения экономики, магазина и новых механик.',
        ],
        result: 'Мини-приложение превратилось в игровую механику внутри Telegram: пользователь выращивает бонсай, получает награды и возвращается за прогрессом.',
        resultMetric: 'Упор сделали на удержание, прогрессию и игровые действия внутри Telegram.',
      },
      {
        title: 'Hotdrop Case',
        portfolioFiles: ['t2-b.webp', 't2-1f.webp', 't2-2f.webp'],
        cardText: 'Telegram Mini App для игровой механики со скинами, кейсами, заданиями, внутренней валютой и наградами',
        niche: 'Telegram Mini App',
        timeline: '25–40 дней',
        priceFrom: '180 000 ₽',
        priceRange: '180 000–380 000 ₽',
        problem: 'Нужно было собрать Telegram Mini App с игровой экономикой, где пользователь понимает баланс, задания, кейсы и операции с валютой.',
        solution: ['Telegram Mini App с игровым dark-интерфейсом, профилем игрока, балансом валюты, заданиями, реферальной системой, магазином кейсов, обменом токенов и экраном подтверждения операции.'],
        link: 'https://t.me/myhotdropbot',
        deliverables: ['Игровой кабинет внутри Telegram без перехода на сайт.', 'Понятная система баланса, заданий и наград.', 'Магазин кейсов и сценарии действий с валютой.', 'Интерфейс с сильной игровой стилистикой и быстрыми CTA.', 'Структура для расширения рефералов, скинов и новых механик.'],
        result: 'Пользователь получает игровой кабинет прямо в Telegram: видит прогресс, выполняет задания, открывает кейсы и управляет валютой.',
        resultMetric: 'Собрали основу игровой экономики с акцентом на действия и возврат пользователя.',
      },
      {
        title: 'ЛК Китайщина',
        portfolioFiles: ['t3-b.webp', 't3-1f.webp', 't3-2f.webp'],
        link: 'https://t.me/CNORIGINAL_bot',
        cardText: 'Telegram-бот и мини-приложение для сервиса доставки товаров из Китая с заказами, складами, профилем и оплатой подписки',
        niche: 'Telegram Bot / Mini App',
        timeline: '20–35 дней',
        priceFrom: '150 000 ₽',
        priceRange: '150 000–320 000 ₽',
        problem: 'Клиентам сервиса доставки нужно было дать личный кабинет прямо в Telegram, чтобы меньше вопросов уходило в ручную поддержку.',
        solution: ['Telegram-бот с меню и мини-приложением личного кабинета: главный экран с быстрыми разделами, создание нового заказа, список заказов, склады в Китае, профиль клиента, код получения, поддержка и экран подтверждения оплаты.'],
        deliverables: [
          'Личный кабинет клиента без отдельного сайта и лишних авторизаций.',
          'Понятный сценарий оформления и просмотра заказов.',
          'Доступ к складам, профилю, оплате и поддержке из одного места.',
          'Снижение ручных вопросов по статусам и данным клиента.',
          'Структура для развития сервиса доставки внутри Telegram.',
        ],
        result: 'Пользователь может оформлять заказы, смотреть данные, управлять профилем и оплатой прямо в Telegram, не переходя в отдельный сервис.',
        resultMetric: 'Главный результат — меньше ручной коммуникации и удобнее путь клиента.',
      },
      {
        title: 'Dzenvlesu Bot',
        portfolioFiles: ['t4-b.webp', 't4-1f.webp', 't4-2f.webp'],
        cardText: 'Telegram-бот для бронирования загородного дома с фото-презентацией, календарём дат, деталями проживания и инструкциями по оплате',
        niche: 'Telegram Bot',
        timeline: '10–18 дней',
        priceFrom: '70 000 ₽',
        priceRange: '70 000–150 000 ₽',
        problem: 'В бронировании дома много повторяющихся вопросов: фото, свободные даты, правила, предоплата и заезд — всё это нужно было автоматизировать.',
        solution: ['Telegram-бот для аренды загородного дома с фото-презентацией объекта, описанием условий, календарём доступных дат, сценарием бронирования, инструкциями по проживанию и сообщениями для подтверждения оплаты.'],
        link: 'https://t.me/DzenvlesuBot',
        deliverables: ['Понятный сценарий бронирования прямо в Telegram.', 'Фото и условия проживания без ручной отправки каждому гостю.', 'Выбор дат и заявка на бронь в одном диалоге.', 'Автоматическая выдача инструкций по оплате и заезду.', 'Основа для добавления новых домов, сезонов и цен.'],
        result: 'Бот помогает гостю пройти путь от знакомства с домом до заявки и инструкций по оплате без постоянной ручной переписки.',
        resultMetric: 'Автоматизировали повторяющиеся вопросы и первый этап бронирования.',
      },
      {
        title: 'Sales Assistant',
        portfolioFiles: [],
        cardText: 'Бот для заявок, уведомлений и первичной квалификации лида',
        niche: 'Онлайн-школа',
        timeline: '10 дней',
        priceFrom: '80 000 ₽',
        priceRange: '80 000–140 000 ₽',
        problem: 'Команде нужно было быстрее обрабатывать входящие заявки и не терять лидов из-за ручной коммуникации.',
        solution: ['Подключил обработку заявок и уведомлений для команды в понятном формате.'],
        result: 'Бот помогает быстрее реагировать на заявки и передавать команде уже более понятный запрос от клиента.',
        resultMetric: 'Снизили ручную рутину и сделали обработку входящих стабильнее.',
        deliverables: [
          'Бот для первичной обработки заявок без ручного разбора каждого сообщения.',
          'Уведомления для команды в понятном формате.',
          'Сценарий квалификации лида до передачи менеджеру.',
          'Меньше хаоса во входящих обращениях.',
          'Основа для расширения под новые воронки и источники заявок.',
        ],
      },
    ],
  },
};
const UNUSED_WORK_CASE_TITLES = new Set(['Landscape Moscow', 'UX Webinar Landing', 'Kudo Russia']);

export const UNUSED_WORK_CASES = {
  landing: WORK_CASE_TEMPLATES.landing.cases.filter((caseItem) => UNUSED_WORK_CASE_TITLES.has(caseItem.title)),
};

WORK_CASE_TEMPLATES.landing.cases = WORK_CASE_TEMPLATES.landing.cases.filter((caseItem) => !UNUSED_WORK_CASE_TITLES.has(caseItem.title));

const isFullImageFile = (fileName) => /-(?:\d+f|f\d*|f)(?:-sm)?\.(png|webp)$/i.test(fileName);
const isPreviewImageFile = (fileName) => /-b(?:-sm)?\.(png|webp)$/i.test(fileName);

const getFullImageOrder = (fileName) => {
  const directOrderMatch = fileName.match(/-(\d+)f(?:-sm)?\./i);
  if (directOrderMatch) {
    return Number(directOrderMatch[1]);
  }

  const suffixOrderMatch = fileName.match(/-f(\d+)(?:-sm)?\./i);
  if (suffixOrderMatch) {
    return Number(suffixOrderMatch[1]);
  }

  if (/-f(?:-sm)?\.(png|webp)$/i.test(fileName)) {
    return 1;
  }

  return Number.MAX_SAFE_INTEGER;
};

const getFullImagesByBase = (baseName, portfolioFiles) =>
  (portfolioFiles || [])
    .filter((fileName) => {
      const isCurrentBase = fileName.startsWith(`${baseName}-`);
      const isFullImage = isFullImageFile(fileName);
      return isCurrentBase && isFullImage;
    })
    .sort((a, b) => {
      const indexA = getFullImageOrder(a);
      const indexB = getFullImageOrder(b);
      if (indexA === indexB) {
        return a.localeCompare(b);
      }
      return indexA - indexB;
    })
    .map((fileName) => `/img-webp/portfolio/${fileName}`);

const getFirstFullImage = (baseName, fallbackPath, portfolioFiles) => {
  const fullCandidates = getFullImagesByBase(baseName, portfolioFiles);
  if (!fullCandidates.length) {
    return fallbackPath;
  }

  return fullCandidates[0];
};

const getGalleryImages = (baseName, previewPath, portfolioFiles) => {
  const fullCandidates = getFullImagesByBase(baseName, portfolioFiles);
  return [previewPath, ...fullCandidates];
};

const getBaseNameFromPreview = (previewFileName) => previewFileName.replace(/\.[^.]+$/, '').replace(/-b(?:-sm)?$/i, '');

export const WORK_CASES = Object.entries(WORK_CASE_TEMPLATES)
  .flatMap(([category, template]) => {
    return template.cases
      .map((caseData) => {
        const caseFiles = caseData.portfolioFiles || [];
        const previewFileName = caseFiles.find(isPreviewImageFile);

        if (!previewFileName) {
          return null;
        }

        const previewPath = `/img-webp/portfolio/${previewFileName}`;
        const id = previewFileName.replace(/\.[^.]+$/, '');
        const baseName = getBaseNameFromPreview(previewFileName);
        return {
          id,
          category,
          serviceType: template.serviceType,
          title: caseData.title,
          cardText: caseData.cardText,
          niche: caseData.niche,
          problem: caseData.problem,
          solution: caseData.solution,
          deliverables: caseData.deliverables,
          result: caseData.result,
          resultMetric: caseData.resultMetric,
          timeline: caseData.timeline,
          priceFrom: caseData.priceFrom,
          priceRange: caseData.priceRange,
          tags: template.tags,
          prev: previewPath,
          full: getFirstFullImage(baseName, previewPath, caseFiles),
          gallery: getGalleryImages(baseName, previewPath, caseFiles),
          link: caseData.link || '',
          proofType: template.proofType,
          proofLabel: template.proofLabel,
          ctaText: template.ctaText,
        };
      })
      .filter(Boolean);
  })
  .filter((caseItem) => !UNUSED_WORK_CASE_TITLES.has(caseItem.title));

export const SERVICES_CONTENT = {
  title: 'Услуги под ключ и точечные доработки',
  cardCta: 'Что входит и какой результат',
  items: [
    {
      id: 'fullstack',
      icon: 'browser',
      name: 'Веб-приложение под ключ: React + Node.js',
      hoverColor: 'var(--color-service-fullstack)',
      hoverShadow: 'var(--shadow-service-fullstack)',
      wide: true,
      shortDesc: 'Собираю MVP, сервисы и внутренние системы: от интерфейса и API до базы данных, деплоя и поддержки после запуска.',
      forWhom: ['Когда нужен рабочий продукт, а не просто набор экранов', 'Когда нужно быстро проверить идею, MVP или новый сервис', 'Когда проект включает кабинет, роли, API, базу данных и интеграции', 'Когда хочется работать с одним исполнителем по frontend и backend'],
      deliverables: ['Frontend и backend под ваш бизнес-процесс', 'База данных, роли, доступы и основные пользовательские сценарии', 'Интеграции, формы, уведомления и административная часть при необходимости', 'Запуск проекта, тестирование и базовая документация для передачи'],
      timeline: '20–60 дней',
      priceRange: 'от 40 000 ₽',
      ctaText: 'Обсудить full-stack проект',
    },
    {
      id: 'layout',
      icon: 'layout',
      name: 'Лендинги и сайты из Figma под запуск рекламы',
      hoverColor: 'var(--color-service-layout)',
      hoverShadow: 'var(--color-ink-20)',
      shortDesc: 'Верстаю адаптивные страницы, которые быстро открываются, корректно выглядят на телефонах и готовы принимать трафик.',
      forWhom: [
        'Когда нужен лендинг под рекламу, запуск продукта или новую услугу',
        'Когда дизайн уже есть в Figma/PSD и его нужно аккуратно перенести в код',
        'Когда важны адаптивность, скорость загрузки и понятный срок запуска',
        'Когда нужно подключить формы, кнопки, анимации и базовый интерактив',
      ],
      deliverables: ['Адаптивная верстка под основные разрешения', 'Подключенные формы, кнопки, якоря и интерактивные элементы', 'Чистая структура блоков, которую можно развивать дальше', 'Подготовка к размещению на хостинге или интеграции с CMS'],
      timeline: '4–10 дней',
      priceRange: 'от 15 000 ₽',
      ctaText: 'Обсудить лендинг',
    },
    {
      id: 'telegram-bot',
      icon: 'telegram',
      name: 'Telegram-боты для заявок, оплат и автоматизации',
      hoverColor: 'var(--color-service-telegram)',
      hoverShadow: 'var(--color-ink-21)',
      shortDesc: 'Настраиваю бота, который принимает заявки, отвечает клиентам, передаёт данные в таблицы/CRM и разгружает менеджеров.',
      forWhom: ['Когда нужно быстрее обрабатывать заявки без расширения штата', 'Когда клиенты часто пишут однотипные вопросы', 'Когда нужно собирать заявки, записи или оплаты прямо в Telegram', 'Когда хочется связать Telegram с таблицами, CRM или внутренней системой'],
      deliverables: ['Продуманный сценарий диалога под вашу задачу', 'Telegram-бот с нужными кнопками, формами и логикой', 'Интеграции с таблицами, CRM, API или уведомлениями', 'Запуск, тестирование и короткая инструкция для команды'],
      timeline: '7–21 день',
      priceRange: 'от 15 000 ₽',
      ctaText: 'Рассчитать Telegram-бота',
    },
    {
      id: 'frontend',
      icon: 'frontend',
      name: 'React-интерфейсы, личные кабинеты и админки',
      hoverColor: 'var(--color-service-frontend)',
      hoverShadow: 'var(--color-ink-25)',
      shortDesc: 'Разрабатываю удобные интерфейсы с API, формами, фильтрами, таблицами, ролями и обработкой ошибок.',
      forWhom: ['Когда backend уже есть и нужен качественный frontend', 'Когда нужно собрать личный кабинет, админку или внутренний интерфейс', 'Когда важны понятная логика, скорость работы и удобство для пользователей', 'Когда в проекте много форм, состояний, фильтров и сценариев'],
      deliverables: ['React-интерфейс под реальные бизнес-сценарии', 'Интеграция с API, формами, таблицами и состояниями', 'Корректная обработка загрузок, ошибок и пустых состояний', 'Поддерживаемая структура компонентов для роста проекта'],
      timeline: '10–30 дней',
      priceRange: 'от 20 000 ₽',
      ctaText: 'Обсудить React-задачу',
    },
    {
      id: 'wordpress',
      icon: 'wordpress',
      name: 'WordPress: доработка сайта без переделки с нуля',
      hoverColor: 'var(--color-service-wordpress)',
      hoverShadow: 'var(--shadow-service-wordpress)',
      shortDesc: 'Исправляю ошибки, добавляю новые блоки, улучшаю скорость и аккуратно дорабатываю текущий сайт без поломки существующего.',
      forWhom: ['Когда сайт уже работает, но нужны правки, новые блоки или страницы', 'Когда текущий сайт неудобно обновлять или сложно поддерживать', 'Когда нужно ускорить сайт и убрать технические проблемы', 'Когда важно доработать проект без хаоса и полной переделки'],
      deliverables: ['Понятный список задач и оценка до старта', 'Аккуратные правки в текущей теме или структуре сайта', 'Проверка ключевых страниц, форм и адаптивности после изменений', 'Рекомендации, что стоит улучшить следующим этапом'],
      timeline: '3–14 дней',
      priceRange: 'от 10 000 ₽',
      ctaText: 'Обсудить WordPress-задачу',
    },
    {
      id: 'backend',
      icon: 'backend',
      name: 'Back-end на Node.js: API, база и интеграции',
      hoverColor: 'var(--color-service-backend)',
      hoverShadow: 'var(--shadow-service-backend)',
      shortDesc: 'Делаю серверную часть для сайтов и приложений: авторизация, база данных, API, WebSocket, оплаты и внешние сервисы.',
      forWhom: ['Когда проекту нужна стабильная серверная логика', 'Когда нужно связать сайт, приложение, CRM, бота или внешний сервис', 'Когда важны роли, авторизация, хранение данных и безопасность', 'Когда проект растёт и текущая логика уже не справляется'],
      deliverables: ['REST API под нужные сценарии проекта', 'Структура базы данных и основная серверная логика', 'Интеграции с внешними сервисами, оплатами или уведомлениями', 'Развёртывание, проверка и передача доступов'],
      timeline: '7–21 день',
      priceRange: 'от 15 000 ₽',
      ctaText: 'Обсудить backend',
    },
  ],
};

export const PRICES_CONTENT = {
  title: 'Стоимость и сроки по типовым задачам',
  subtitle: 'Ниже рабочие диапазоны. После короткого брифа в Telegram в этот же день фиксирую этапы, сроки и бюджетный коридор.',
  factorsTitle: 'Что влияет на финальную стоимость:',
  factors: ['Объем страниц, ролей и бизнес-сценариев', 'Интеграции: CRM, платежи, внешние API', 'Срочность запуска и глубина доработок'],
  ctaText: 'Получить смету и план в Telegram',
  items: [
    { id: 'telegram', name: 'Telegram-бот (Node.js)', priceRange: '30 000–120 000 ₽', timeline: '7–21 день' },
    { id: 'layout', name: 'Верстка / лендинг', priceRange: '20 000–55 000 ₽', timeline: '4–10 дней' },
    { id: 'wordpress', name: 'WordPress натяжка', priceRange: '35 000–90 000 ₽', timeline: '6–14 дней' },
    { id: 'frontend', name: 'Front-end React', priceRange: '60 000–180 000 ₽', timeline: '10–30 дней' },
    { id: 'fullstack', name: 'Full-stack React + Node.js', priceRange: '140 000–420 000 ₽', timeline: '20–60 дней' },
  ],
};

export const PROOF_CONTENT = {
  title: 'Подтверждения и опыт',
  subtitle: 'Ключевые показатели по проектам и коммуникации. Детали по NDA показываю в личном диалоге.',
  proofItems: [
    { id: 'proof-1', label: 'Опыт в коммерции', value: '4+ года', text: 'Проекты для малого и среднего бизнеса: лендинги, боты и веб-приложения.' },
    { id: 'proof-2', label: 'Запущенные проекты', value: '20+', text: 'Релизы по верстке, WordPress, React/Node.js и Telegram-автоматизации.' },
    { id: 'proof-3', label: 'Скорость ответа', value: 'до 15 мин', text: 'Быстрый первый контакт в Telegram и оценка в день обращения.' },
  ],
  testimonials: [
    {
      id: 'review-slot-1',
      isPlaceholder: true,
      title: 'Слот под реальный отзыв #1',
      text: 'Добавьте скрин/цитату клиента: задача, срок, что получили на выходе.',
    },
    {
      id: 'review-slot-2',
      isPlaceholder: true,
      title: 'Слот под реальный отзыв #2',
      text: 'Лучше всего работают отзывы с цифрами результата и именем/нишой клиента.',
    },
    {
      id: 'review-slot-3',
      isPlaceholder: true,
      title: 'Слот под реальный отзыв #3',
      text: 'Для NDA добавьте анонимный кейс с подтверждаемым эффектом.',
    },
  ],
};

export const FAQ_CONTENT = {
  title: 'FAQ перед стартом работы',
  subtitle: 'Коротко о сроках, оплате, процессе и том, как проходит работа над проектом.',
  items: [
    {
      id: 'faq-1',
      question: 'Как быстро вы отвечаете и даете оценку?',
      answer: 'Обычно отвечаю в Telegram в течение 15–30 минут. В день обращения отправляю примерный план работ, сроки и диапазон стоимости.',
    },
    {
      id: 'faq-2',
      question: 'Можно ли начать без готового ТЗ?',
      answer: 'Да. Достаточно описать задачу своими словами, показать примеры или рассказать цель проекта. Помогу собрать это в понятный план.',
    },
    {
      id: 'faq-3',
      question: 'Как проходит оплата?',
      answer: 'Работа делится на этапы. Перед стартом фиксируем объем работ, сроки, стоимость и ожидаемый результат каждого этапа.',
    },
    {
      id: 'faq-4',
      question: 'Сколько обычно занимает запуск проекта?',
      answer: 'Лендинги и небольшие сайты — от 7 дней. Telegram-боты и mini apps — обычно от 2 до 5 недель в зависимости от сложности.',
    },
    {
      id: 'faq-5',
      question: 'Вы работаете только с дизайном или с разработкой тоже?',
      answer: 'Берусь за проект под ключ: структура, дизайн, frontend, backend, интеграции, Telegram-боты и запуск на сервер.',
    },
    {
      id: 'faq-6',
      question: 'Можно ли вносить правки по ходу работы?',
      answer: 'Да. Согласованные правки внутри этапа включены. Важные изменения обсуждаем отдельно, чтобы не ломать сроки проекта.',
    },
    {
      id: 'faq-7',
      question: 'Что происходит после запуска?',
      answer: 'Передаю доступы, инструкции и рекомендации по развитию проекта. При необходимости могу остаться на поддержке и доработках.',
    },
    {
      id: 'faq-8',
      question: 'Вы работаете с клиентами из других стран?',
      answer: 'Да. Работаю удаленно с проектами из СНГ, Европы и других стран. Общение — Telegram, Google Meet или удобный вам формат.',
    },
    {
      id: 'faq-9',
      question: 'Можно ли заказать только часть работы?',
      answer: 'Да. Можно обратиться отдельно за дизайном, frontend/backend разработкой, Telegram-ботом, mini app или доработкой существующего проекта.',
    },
  ],
};

export const CONTACT_CONTENT = {
  title: 'Опишите задачу в Telegram и получите план запуска сегодня',
  subtitle: 'Пришлите тип задачи, желаемый срок и бюджетный ориентир. Первый ответ — до 15 минут.',
  ctaText: 'Написать в Telegram и получить план',
  steps: ['Тип задачи и цель проекта', 'Желаемый срок запуска', 'Ориентир по бюджету и референсы'],
};

//  {
//         title: 'Kudo Russia',
//         portfolioFiles: [],
//         cardText: 'Корпоративный сайт для спортивной федерации с разделами соревнований, клубов, спортсменов, медиа и партнёров',
//         niche: 'Лендинг + WordPress',
//         timeline: '18–25 дней',
//         priceFrom: '120 000 ₽',
//         priceRange: '120 000–220 000 ₽',

//         problem: 'Нужно было собрать большой объём информации о федерации в понятную структуру: соревнования, клубы, спортсмены, медиа, партнёры и внутренние разделы сайта.',

//         solution: ['WordPress-сайт для спортивной федерации с яркой главной страницей, навигацией по ключевым разделам, карточками спортсменов, блоком соревнований, медиа-разделом и партнёрскими блоками.'],

//         deliverables: [
//           'Главная страница с выразительным первым экраном и быстрым переходом к основным разделам.',
//           'Структура для соревнований, клубов, спортсменов, медиа, экипировки и партнёров.',
//           'Карточки спортсменов с фото, кратким описанием и спортивной информацией.',
//           'Медиа-блок для новостей, материалов и публикаций федерации.',
//           'Отдельные блоки для фонда, экипировочного центра, партнёров и спонсоров.',
//           'Адаптивная верстка и возможность обновлять контент через WordPress.',
//         ],

//         result: 'Сайт стал центральной витриной федерации: посетитель может быстро найти соревнования, клубы, спортсменов, новости, партнёров и нужные разделы без путаницы.',

//         resultMetric: 'Готовый WordPress-сайт для спортивной организации: навигация по разделам, карточки участников, медиа, партнёры и структура под регулярное обновление контента.',
//       },
//       {
//         title: 'UX Webinar Landing',
//         portfolioFiles: [],
//         cardText: 'Лендинг для регистрации на бесплатный вебинар с формой заявки, программой занятия и продающими блоками',
//         niche: 'Лендинг + WordPress',
//         timeline: '10–14 дней',
//         priceFrom: '70 000 ₽',
//         priceRange: '70 000–120 000 ₽',

//         problem: 'Нужно было быстро объяснить ценность бесплатного занятия, показать эксперта и довести посетителя до регистрации без лишних переходов.',

//         solution: ['WordPress-лендинг для вебинара с сильным первым экраном, формой регистрации, программой занятия, блоками пользы, описанием эксперта и повторным CTA в конце страницы.'],

//         deliverables: [
//           'Первый экран с темой вебинара, экспертом, датой, форматом и формой регистрации.',
//           'Блок программы занятия с понятной структурой и визуальным разделением тем.',
//           'Продающий блок с акцентом на пользу бесплатного вебинара.',
//           'Секция об эксперте и объяснение, зачем бизнесу UX-дизайн.',
//           'Повторная форма заявки внизу страницы для сбора регистраций.',
//           'Адаптивная верстка и возможность редактировать контент через WordPress.',
//         ],

//         result: 'Лендинг собирает заявки на вебинар прямо на странице: пользователь видит тему, пользу, эксперта, дату и может сразу зарегистрироваться.',

//         resultMetric: 'Готовый WordPress-лендинг под рекламный трафик: несколько точек заявки, программа вебинара и продающая структура для регистрации.',
//       },
//       {
//         title: 'Beauty Landing',
//         portfolioFiles: [],
//         cardText: 'Сайт-визитка с фокусом на входящие заявки из соцсетей',
//         niche: 'Красота',
//         timeline: '6 дней',
//         priceFrom: '80 000 ₽',
//         priceRange: '80 000–140 000 ₽',
//         problem: 'Нужно было быстро запустить сайт под рекламу и входящие заявки.',
//         solution: ['Собрал адаптивную верстку, выстроил структуру блоков под заявки и подключил формы.'],
//         result: 'Проект запущен в оговоренный срок и сразу готов к трафику.',
//         resultMetric: 'Запуск за 8 дней, первые обращения в первую неделю',
//       },
//       {
//         title: 'Auto Service',
//         portfolioFiles: [],
//         cardText: 'Промо-сайт с акцентом на доверие и конверсию в обращения',
//         niche: 'Локальный бизнес',
//         timeline: '8 дней',
//         priceFrom: '55 000 ₽',
//         priceRange: '55 000–90 000 ₽',
//         problem: 'Клиенту требовался обновленный лендинг с более ясной подачей оффера.',
//         solution: ['Подготовил WordPress-основу для удобного редактирования контента и быстрых правок.'],
//         result: 'Клиент получил сайт, который можно развивать без полной переделки.',
//         resultMetric: 'Запуск за 10 дней с передачей инструкции в день релиза',
//       },
//       {
//         title: 'Landscape Moscow',
//         portfolioFiles: [],
//         cardText: 'Имиджевый сайт для ландшафтной студии с портфолио, услугами, сертификатами и формой заявки',
//         niche: 'Лендинг + WordPress',
//         timeline: '14–18 дней',
//         priceFrom: '80 000 ₽',
//         priceRange: '80 000–140 000 ₽',

//         problem: 'Нужно было показать экспертность студии через визуал, проекты и сертификаты, не перегружая сайт лишним текстом.',

//         solution: ['Имиджевый WordPress-сайт с адаптивной версткой, портфолио проектов, услугами, сертификатами и формой консультации.'],

//         deliverables: [
//           'Атмосферная визуальная подача проектов и услуг студии.',
//           'Единая структура для портфолио, сертификатов и заявок.',
//           'Адаптивный интерфейс для мобильных устройств и desktop.',
//           'Удобное редактирование контента через WordPress.',
//           'Подготовленная структура под рекламу и прямые обращения клиентов.',
//         ],

//         result: 'Сайт стал презентацией студии для клиентов: можно быстро оценить стиль работ, уровень доверия и оставить заявку на консультацию.',

//         resultMetric: 'Готовый WordPress-сайт под рекламу и прямые обращения: портфолио, услуги, сертификаты и форма заявки в одной структуре.',
//       },
